import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import swal from 'sweetalert2'
import Preloader from '../preloader/Preloader'
import $ from 'jquery'

//components
import { DataTableItem, UserRoute, BreadCrumb, Card } from 'src/components'

//services
import { getSpreadChargeRate, deleteSpreadChargeRate } from 'src/services'

function ChargeRate() {
  const [loading, setLoading] = useState(true)
  const [inputList, setInputList] = useState([])

  useEffect(() => {
    getSpreadChargeRate()
      .then((res) => {
        if (res.data.status === 200) {
          setInputList(res.data.spread_charge)
        }
        setTimeout(() => {
          $('#dataTable').DataTable({
            scrollX: false,
            pageLength: 100,
          })
        }, 10)
        setLoading(false)
      })
      .catch(() => {
        setTimeout(() => {
          $('#dataTable').DataTable({
            scrollX: false,
            pageLength: 100,
          })
        }, 10)
        setLoading(false)
      })
  }, [])

  const deleteRecord = (e, id) => {
    e.preventDefault()

    const thisClicked = e.currentTarget

    swal
      .fire({
        title: 'Are you sure you want to proceed?',
        text: 'This will completely delete the Operators permanently',
        icon: 'warning',
        showDenyButton: true,
        denyButtonText: 'Cancel!',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Proceed!',
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteSpreadChargeRate(id)
            .then((res) => {
              if (res.data.status === 200) {
                swal.fire('Deleted!', res.data.message, 'success')
                thisClicked.closest('tr').remove()
              } else if (res.data.status === 404) {
                swal.fire('Error', res.data.message, 'error')
              }
            })
            .catch(() => {
              setTimeout(() => {
                $('#dataTable').DataTable({
                  scrollX: false,
                  pageLength: 100,
                })
              }, 10)
              setLoading(false)
            })
        } else if (result.isDenied) {
          swal.fire('Changes are not saved', '', 'info')
        }
      })
  }

  const renderRowActions = (item) => {
    return (
      <>
        <Link to={`/spread_charge_rate/update/${item.id}`} className="btn btn-info me-2">
          Edit
        </Link>
        <button onClick={(e) => deleteRecord(e, item.id)} className="btn btn-danger">
          Delete
        </button>
      </>
    )
  }

  const columns = [
    { label: 'Name', key: 'name' },
    { label: 'Xero Code', key: 'xero_code' },
    // ... other columns
  ]

  const title = 'Spread Charge Rate'

  const breadcrumb = [
    {
      title: title,
      name: 'Add Spread Charge Rate',
      subtitle: '',
      subtitleroute: '',
    },
  ]

  const buttonValues = [
    {
      title: 'Add Spread Charge Rate',
      variants: 'btn btn-primary my-3 mr-2',
      routes: '/spread_charge_rate/create',
    },
  ]

  const cardValues = [
    {
      title: title,
    },
  ]

  return (
    <div>
      <BreadCrumb data={breadcrumb} />
      <UserRoute data={buttonValues} />

      <Card data={cardValues}>
        {<DataTableItem data={inputList} columns={columns} renderRowActions={renderRowActions} />}
      </Card>
    </div>
  )
}

export default ChargeRate
